import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import { DataGrid } from 'devextreme-react';
import { Box } from '@mui/material';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { ISubAnalysis } from 'interfaces/Pricelist/ISubAnalysis';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';
import SubAnalysisCell from './components/SubAnalysisCell';

const SubAnalysis = (props: IPricelistMasterDetailProps) => {
  const { getSubAnalysisInfo } = PricelistApis();
  const [error, setError] = useState('');
  const [loadingSubAnalysis, setLoadingSubAnalysis] = useState<boolean>(true);
  const [subAnalysisInfo, setSubAnalysisInfo] = useState<ISubAnalysis[] | undefined>();

  useEffect(() => {
    getSubAnalysisInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setSubAnalysisInfo(data);
        }
      })
      .catch((e) => setError(e))
      .finally(() => setLoadingSubAnalysis(false));
  }, [props, getSubAnalysisInfo]);

  return (
    <Box className="subAnalysisInfo">
      {error && !(subAnalysisInfo?.length > 0) ? <Box className="errorBox">{error}</Box> : null}
      {!error && loadingSubAnalysis ? <Box className="loadingBox">Loading Sub Analysis...</Box> : null}
      {!error && loadingSubAnalysis && subAnalysisInfo?.length === 0  ? <Box><h2>No Sub Analysis available</h2></Box> : null }
      {!loadingSubAnalysis && subAnalysisInfo?.length > 0 ?
      <DataGrid
        dataSource={subAnalysisInfo}
        rowAlternationEnabled={true}
        showBorders={false}
        wordWrapEnabled={true}
        hoverStateEnabled={false}
        paging={{ enabled: false }}
        headerFilter={{ visible: false }}
        columns={[
          { dataField: "Code", caption: "Code", sortOrder: "asc", width: 110, dataType: "string" },
          { dataField: "Description", dataType: "string" },
          { dataField: "Method", width: 250, dataType: "string" },
          { dataField: "Container", width: 200, dataType: "string" },
          { dataField: "HoldingTime", caption: "Hold Time", width: 80, alignment: "center", dataType: "string" },
          { dataField: "Facility", width: 200, dataType: "string" },
          {
            width: 130,
            caption: "",
            dataType: "string",
            cellTemplate: (container, options) => {
              const root = ReactDOM.createRoot(container);
              root.render(<SubAnalysisCell {...options?.data} />);
            },
          },
        ]}
      /> : null }
    </Box>
  )
};

export default React.memo(SubAnalysis);
